// snackbar.ts
export function showSnackbar(header?: string, message?: string) {
    // Only show if we have content
    if (!header && !message) return;

    // Remove any existing snackbars
    const existing = document.querySelector(".snackbar");
    if (existing) {
        existing.classList.remove("show");
        setTimeout(() => existing.remove(), 300); // allow fade-out animation
    }

    // Create snackbar container
    const snackbar = document.createElement("div");
    snackbar.className = "snackbar show"; // "show" triggers CSS animation

    // Optional: add header
    if (header) {
        const headerElem = document.createElement("div");
        headerElem.className = "snackbar-header";
        headerElem.textContent = header;
        snackbar.appendChild(headerElem);
    }

    // Add message
    if (message) {
        const messageElem = document.createElement("div");
        messageElem.className = "snackbar-message";
        messageElem.textContent = message;
        snackbar.appendChild(messageElem);
    }

    // Append to body (or a container div)
    document.body.appendChild(snackbar);

    // Remove after timeout
    setTimeout(() => {
        snackbar.classList.remove("show");
        // Give time for CSS fade-out animation, then remove
        setTimeout(() => snackbar.remove(), 300);
    }, 3500);
}